import React from "react";
import { useForm } from "react-hook-form";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  Typography,
  Button,
  Grid,
  Divider,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { registerCustomer } from "../../../api/authApi";

function Register() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      Object.keys(data).forEach((key) => {
        if (data[key] === "") data[key] = undefined;
      });
      await registerCustomer(data);
      alert("Kayıt başarılı!");
    } catch {
      alert("Kayıt başarısız!");
    }
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      style={{
        maxWidth: 950,
        margin: "40px auto",
        background: "#fff",
        padding: 32,
        borderRadius: 12,
        boxShadow: "0 2px 16px #0001",
      }}
      autoComplete="off"
    >
      <Typography variant="h5" fontWeight={700} textAlign="center" mb={3}>
        Kayıt Ol
      </Typography>
      <Divider sx={{ mb: 3 }} />

      {/* Başvuru Yapan Kişi */}
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={600} color="primary">
            Başvuru Yapan Kişi
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Ad*"
                fullWidth
                {...register("name", { required: "Ad zorunlu" })}
                error={!!errors.name}
                helperText={errors.name?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Soyad*"
                fullWidth
                {...register("surname", { required: "Soyad zorunlu" })}
                error={!!errors.surname}
                helperText={errors.surname?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="E-posta*"
                fullWidth
                {...register("email", { required: "Geçerli e-posta girin" })}
                error={!!errors.email}
                helperText={errors.email?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField label="Telefon" fullWidth {...register("phone")} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Şifre*"
                type="password"
                fullWidth
                {...register("password", {
                  required: "Şifre zorunlu",
                  minLength: { value: 4, message: "En az 4 karakter" },
                })}
                error={!!errors.password}
                helperText={errors.password?.message}
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      {/* Şirket Bilgileri */}
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={600} color="primary">
            Şirket Bilgileri
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Şirket Adı*"
                fullWidth
                {...register("companyName", { required: "Şirket adı zorunlu" })}
                error={!!errors.companyName}
                helperText={errors.companyName?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Ülke"
                fullWidth
                {...register("country")}
                defaultValue="Türkiye"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="İl*"
                fullWidth
                {...register("city", { required: "İl zorunlu" })}
                error={!!errors.city}
                helperText={errors.city?.message}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="İlçe*"
                fullWidth
                {...register("district", { required: "İlçe zorunlu" })}
                error={!!errors.district}
                helperText={errors.district?.message}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField label="Bucak/Kasaba" fullWidth {...register("town")} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Mahalle"
                fullWidth
                {...register("neighborhood")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField label="Sokak" fullWidth {...register("street")} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField label="Site Adı" fullWidth {...register("siteName")} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Bina No"
                fullWidth
                {...register("buildingNo")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField label="Kapı No" fullWidth {...register("doorNo")} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Posta Kodu"
                fullWidth
                {...register("postalCode")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Şirket Telefonu"
                fullWidth
                {...register("companyPhone")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Şirket Fax"
                fullWidth
                {...register("companyFax")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Mobil Telefon"
                fullWidth
                {...register("mobilePhone")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Şirket E-posta"
                fullWidth
                {...register("companyEmail")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Şirket Web"
                fullWidth
                {...register("companyWeb")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Vergi Dairesi"
                fullWidth
                {...register("taxOffice")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Vergi Numarası*"
                fullWidth
                {...register("taxNo", { required: "Vergi numarası zorunlu" })}
                error={!!errors.taxNo}
                helperText={errors.taxNo?.message}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Ticaret Odası"
                fullWidth
                {...register("chamberOfCommerce")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Ticaret Sicil No"
                fullWidth
                {...register("chamberNo")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth sx={{ width: 280 }}>
                <InputLabel id="eInvoiceLabel">E-Fatura</InputLabel>
                <Select
                  labelId="eInvoiceLabel"
                  label="E-Fatura"
                  defaultValue=""
                  {...register("eInvoice")}
                >
                  <MenuItem value="">Seçiniz</MenuItem>
                  <MenuItem value="Evet">Evet</MenuItem>
                  <MenuItem value="Hayır">Hayır</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      {/* Fatura Adresi */}
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={600} color="primary">
            Fatura Adresi
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Ülke"
                fullWidth
                {...register("invoiceAddress.country")}
                defaultValue="Türkiye"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Şehir"
                fullWidth
                {...register("invoiceAddress.city")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="İlçe"
                fullWidth
                {...register("invoiceAddress.district")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Bucak/Kasaba"
                fullWidth
                {...register("invoiceAddress.town")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Mahalle"
                fullWidth
                {...register("invoiceAddress.neighborhood")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Sokak"
                fullWidth
                {...register("invoiceAddress.street")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Site Adı"
                fullWidth
                {...register("invoiceAddress.siteName")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Bina No"
                fullWidth
                {...register("invoiceAddress.buildingNo")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Kapı No"
                fullWidth
                {...register("invoiceAddress.doorNo")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Posta Kodu"
                fullWidth
                {...register("invoiceAddress.postalCode")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Telefon"
                fullWidth
                {...register("invoiceAddress.phone")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Fax"
                fullWidth
                {...register("invoiceAddress.fax")}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={<Checkbox {...register("invoiceSameAsCompany")} />}
                label="Fatura adresi, şirket adresiyle aynı"
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      {/* Diğer Bilgiler */}
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={600} color="primary">
            Diğer Bilgiler
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                sx={{ width: 280 }}
                label="Çalışan Sayısı"
                fullWidth
                {...register("employeeCount", { valueAsNumber: true })}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                sx={{ width: 280 }}
                label="Yıllık Ciro"
                fullWidth
                {...register("annualTurnover")}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                sx={{ width: 280 }}
                label="Firma Özeti"
                fullWidth
                multiline
                rows={2}
                {...register("companySummary")}
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      {/* İlgilenilen Ürün Grupları ve Belgeler */}
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={600} color="primary">
            Ürün Grupları & Belgeler
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                sx={{ width: 280 }}
                label="İlgilenilen Ürün Grupları (virgülle ayır)"
                fullWidth
                {...register("interestedProductGroups")}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                sx={{ width: 280 }}
                label="Vergi Levhası (Dosya Adı)"
                fullWidth
                {...register("documents.taxSheet")}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                sx={{ width: 280 }}
                label="Ticaret Sicil Gazetesi (Dosya Adı)"
                fullWidth
                {...register("documents.chamberGazette")}
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      <Button
        type="submit"
        fullWidth
        variant="contained"
        sx={{ mt: 4, fontWeight: 700, fontSize: 18 }}
      >
        Kayıt Ol
      </Button>
    </form>
  );
}

export default Register;
